class GtagService {
  static async gtagEventAndNavigate({
    event,
    params = {},
    targetUrl,
    timeout = 200,
  }) {
    return new Promise((resolve) => {
      if (typeof gtag !== "function") {
        console.warn("gtag is not available");

        if (targetUrl) {
          window.location.href = targetUrl;
        }

        resolve();
        return;
      }

      let navigated = false;

      const navigate = () => {
        if (navigated || !targetUrl) return;
        navigated = true;
        window.location.href = targetUrl;
        resolve();
      };

      const commonParams = {
        transport_type: "beacon",
        event_callback: navigate,
      };

      gtag("event", event, {
        ...params,
        ...commonParams,
      });

      setTimeout(() => {
        if (!navigated && targetUrl) {
          navigate();
        }
      }, timeout);
    });
  }
}

export default GtagService;
